import { NgModule } from '@angular/core';
import { LocalizationModule } from './Localization/localization.module';
import { CoreDialogsModule } from './Dialogs/dialogs.module';
import { UsersModule } from './Users/users.module';
import { CoreCacheModule } from './Cache/cache.module';
import { LocalizationPipe } from './Localization/pipes/localization.pipe';
import { LocalizationListPipe } from './Localization/pipes/localization-list.pipe';
import { LocalizationFromParamsPipe } from './Localization/pipes/localization-from-params.pipe';
import { ConfigModule } from './Config/config.module';
import { ReactiveFormsModule } from '@angular/forms';


@NgModule({
    imports: [
        LocalizationModule,
        CoreDialogsModule,
        UsersModule,
        CoreCacheModule,
        ConfigModule,
        ReactiveFormsModule
    ],
    exports: [
        // It's not enough to the localization module to export these,
        // they have to be exported again so things using the core module can use them
        LocalizationPipe,
        LocalizationListPipe,
        LocalizationFromParamsPipe,
        CoreDialogsModule
    ]
})
export class CoreModule {
}
